import { render } from "./ServiceItsVehicleCardComp.vue?vue&type=template&id=0e8287e3&scoped=true"
import script from "./ServiceItsVehicleCardComp.vue?vue&type=script&lang=js"
export * from "./ServiceItsVehicleCardComp.vue?vue&type=script&lang=js"

import "./ServiceItsVehicleCardComp.vue?vue&type=style&index=0&id=0e8287e3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e8287e3"]])

export default __exports__